export const LANDING = '/';
export const SIGNIN = '/signin';
export const DASHBOARD = '/dashboard';
export const CURRICULUM = '/curriculum';
export const MODULE = '/module';
export const PROFILE = '/profile';
